<app-header></app-header>
<app-sidebar (collapsedEvent)="receiveCollapsed($event)"></app-sidebar>
<section class="main-container" [ngClass]="{collapsed: collapedSideBar}">
  <div style="min-height: calc(100vh - 9rem);">
    <router-outlet></router-outlet>
  </div>
 
  
</section>

<app-footer></app-footer>
